import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Helmet } from 'react-helmet-async';

import { CONFIG } from 'src/global-config';

import { ProductShopView } from 'src/sections/product/view';

const metadata = { title: `Aktiviteler - ${CONFIG.appName}` };

export default function Page() {
  const accessTokenJSON = localStorage.getItem('auth') as string;
  const accessToken = JSON.parse(accessTokenJSON)?.accessToken ?? null;

  const { anonymous_activitiesAndBlogsData, anonymous_activitiesAndBlogsLoading } = useSelector(
    (state: any) => state.anonymous_activitiesAndBlogs
  );
  const { parent_activitiesAndBlogsData, parent_activitiesAndBlogsLoading } = useSelector(
    (state: any) => state.parent_activitiesAndBlogs
  );
  const [categoryName, setCategoryName] = useState('Aktiviteler');

  return (
    <>
      <Helmet>
        <title> {metadata.title}</title>
      </Helmet>

      <ProductShopView
        products={
          accessToken ? parent_activitiesAndBlogsData?.data : anonymous_activitiesAndBlogsData?.data
        }
        productsCount={
          accessToken
            ? parent_activitiesAndBlogsData?.count
            : anonymous_activitiesAndBlogsData?.count
        }
        loading={
          accessToken ? parent_activitiesAndBlogsLoading : anonymous_activitiesAndBlogsLoading
        }
        categoryName={categoryName}
        setCategoryName={setCategoryName}
      />
    </>
  );
}
